import React from 'react';
import styles from './DraftInfoWithActions.module.scss';
import { Alert, Button } from 'antd';
import { useDraftLocalStorage } from '../../../create/lib';
import moment from 'moment';

const DraftInfoWithActions = ({ form }) => {
  const [draft, setDraft] = useDraftLocalStorage();

  const insertDraft = () => {
    const formValues = {
      ...draft,
      startDate: draft.startDate ? moment(draft.startDate) : null,
      endDate: draft.endDate ? moment(draft.endDate) : null,
      planEndDate: draft.planEndDate ? moment(draft.planEndDate) : null,
    };

    form.setFieldsValue(formValues);
  };

  const deleteDraft = () => setDraft(null);

  const insertAndDeleteDraft = () => {
    insertDraft();
    deleteDraft();
  };

  return draft ? (
    <Alert
      className={styles.root}
      message="У вас есть сохраненный черновик"
      description={
        <div className={styles.actions}>
          <div className={styles.col}>
            <Button
              onClick={deleteDraft}
              type="danger"
              className={styles.btnDelete}
            >
              Удалить
            </Button>
            <Button
              onClick={insertAndDeleteDraft}
              className={styles.btnNormal}
            >
              Вставить и удалить
            </Button>
          </div>

          <Button
            onClick={insertDraft}
            type="primary"
            className={styles.btnPrimary}
          >
            Вставить
          </Button>
        </div>
      }
    />
  ) : null;
};

export default DraftInfoWithActions;
